import { useState } from "react";
import { useEntry, Loading, ErrorBox, Chip, CLS_META, STATE_META } from "./entryShared";
import { CaretDown, CaretUp } from "@phosphor-icons/react";

const DOT = { 0: "bg-red-500", 1: "bg-amber-400", 2: "bg-emerald-600" };

export const CaseTransferability = ({ caseId }) => {
  const { data, error } = useEntry(caseId, "/translation");
  const [open, setOpen] = useState(null);
  if (error) return <ErrorBox error={error} />;
  if (!data) return <Loading />;
  return (
    <div data-testid="case-transferability" className="mt-4">
      <p className="text-xs text-slate-500 mb-3">Every asset assessed on 10 transferability dimensions against <span className="font-bold">{data.target_market?.name}</span> — each classification carries its WHY.</p>
      <div className="space-y-2">
        {(data.assets || []).map((a) => (
          <div key={a.asset_id} className="border border-slate-200 bg-white" data-testid={`transfer-${a.asset_id}`}>
            <button onClick={() => setOpen(open === a.asset_id ? null : a.asset_id)} data-testid={`transfer-toggle-${a.asset_id}`}
              className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-slate-50">
              <div className="min-w-0">
                <p className="text-xs font-bold text-slate-800 truncate">{a.asset_name}</p>
                <p className="text-[10px] text-slate-400 uppercase tracking-wide">{a.asset_type?.replaceAll("_", " ")} · {a.asset_country} · transfer score {a.transfer_score}/100</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <Chip meta={CLS_META[a.classification]} testId={`cls-${a.asset_id}`} />
                {open === a.asset_id ? <CaretUp size={12} /> : <CaretDown size={12} />}
              </div>
            </button>
            <div className="px-4 pb-3 -mt-1">
              <p className="text-[11px] text-slate-600" data-testid={`why-${a.asset_id}`}><span className="font-bold text-slate-800">Why:</span> {a.classification_reason}</p>
            </div>
            {open === a.asset_id && (
              <div className="border-t border-slate-100 px-4 py-3 grid sm:grid-cols-2 gap-2" data-testid={`dims-${a.asset_id}`}>
                {(a.dimensions || []).map((d) => (
                  <div key={d.id} className="flex items-start gap-2">
                    <span className={`w-2 h-2 mt-1 shrink-0 rounded-full ${DOT[d.score]}`} />
                    <div>
                      <p className="text-[11px] font-bold text-slate-700">{d.label} <span className="font-normal text-slate-400">({d.score}/2)</span></p>
                      <p className="text-[10px] text-slate-500">{d.reason}</p>
                    </div>
                  </div>
                ))}
                <div className="sm:col-span-2 mt-1"><Chip meta={STATE_META[a.evidence_state]} /></div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
